import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex"} }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = {
  key: 0,
  class: "ml-10 fz-14 grey-1"
}
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = {
  key: 0,
  class: "summary-box"
}
const _hoisted_7 = { class: "d-flex justify-content-center align-items-end" }
const _hoisted_8 = { class: "partner-statistic-box partner-statistic-box-current" }
const _hoisted_9 = { class: "partner-statistic-count" }
const _hoisted_10 = { class: "partner-statistic-box partner-statistic-box-total" }
const _hoisted_11 = { class: "partner-statistic-count" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "mt-80 mb-50" }
const _hoisted_14 = {
  key: 0,
  class: "sidebar-filters"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 0,
  class: "option-list"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "checkbox-place" }
const _hoisted_20 = {
  key: 1,
  class: "checkbox-border"
}
const _hoisted_21 = { class: "option-list-item-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_search_input_header = _resolveComponent("search-input-header")!
  const _component_QuizFilters = _resolveComponent("QuizFilters")!
  const _component_document_svg = _resolveComponent("document-svg")!
  const _component_new_card = _resolveComponent("new-card")!
  const _component_document_card = _resolveComponent("document-card")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_checked_svg = _resolveComponent("checked-svg")!
  const _component_ciena_layout = _resolveComponent("ciena-layout")!

  return (_openBlock(), _createBlock(_component_ciena_layout, { onOnSearchBarSubmit: _ctx.handleSearch }, {
    "header-left": _withCtx(() => [...(_cache[4] || (_cache[4] = [
      _createElementVNode("span", { class: "heading-4 f-roboto fw-light" }, "EMS Dashboard", -1)
    ]))]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass({
      'dashboard-wrapper': true,
       'is-filter-open': _ctx.isFiltersOpen
      }),
          style: {
      // width: isFiltersOpen ? 'calc(100vw - 640px)' : ' calc(100vw - 320px)',
      padding: '30px 30px 30px 30px',
    }
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[5] || (_cache[5] = _createElementVNode("h4", { class: "box-title" }, "EMS Engagements", -1)),
              (_ctx.progressMessage)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.progressMessage), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _createVNode(_component_search_input_header, {
                  value: _ctx.searchValue,
                  onHandleSubmit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleSearch($event)))
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", {
                class: "show-filter-button mb-32",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openFilter && _ctx.openFilter(...args)))
              }, [
                _cache[6] || (_cache[6] = _createElementVNode("svg", {
                  width: "16",
                  height: "16",
                  viewBox: "0 0 16 16",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    d: "M8 6.5C11.5899 6.5 14.5 5.15685 14.5 3.5C14.5 1.84315 11.5899 0.5 8 0.5C4.41015 0.5 1.5 1.84315 1.5 3.5C1.5 5.15685 4.41015 6.5 8 6.5Z",
                    stroke: "#1F252D",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }),
                  _createElementVNode("path", {
                    d: "M1.5 3.5C1.50082 4.96229 1.99484 6.38155 2.90217 7.5283C3.8095 8.67504 5.0771 9.48223 6.5 9.81933V14C6.5 14.3978 6.65804 14.7794 6.93934 15.0607C7.22064 15.342 7.60218 15.5 8 15.5C8.39782 15.5 8.77936 15.342 9.06066 15.0607C9.34196 14.7794 9.5 14.3978 9.5 14V9.81933C10.9229 9.48223 12.1905 8.67504 13.0978 7.5283C14.0052 6.38155 14.4992 4.96229 14.5 3.5",
                    stroke: "#1F252D",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  })
                ], -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.isFiltersOpen ? 'Hide' : 'Show') + " filter", 1)
              ]),
              (_ctx.haveQuestionSelected())
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "show-filter-button ml-16 mb-32",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clearFilter && _ctx.clearFilter(...args)))
                  }, " Clear filters "))
                : _createCommentVNode("", true),
              _createVNode(_component_QuizFilters, { onOnFilterChange: _ctx.onFilterChange }, null, 8, ["onOnFilterChange"])
            ])
          ]),
          (_ctx.isFiltersOpen)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", null, [
                      _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.pageMeta.total), 1),
                      _cache[7] || (_cache[7] = _createElementVNode("h6", { class: "partner-statistic-label" }, "Partners", -1))
                    ]),
                    _cache[8] || (_cache[8] = _createElementVNode("div", null, [
                      _createElementVNode("svg", {
                        width: "40",
                        height: "40",
                        viewBox: "0 0 40 40",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("rect", {
                          x: "0.5",
                          y: "0.5",
                          width: "39",
                          height: "39",
                          rx: "19.5",
                          fill: "url(#paint0_linear_29_5066)"
                        }),
                        _createElementVNode("rect", {
                          x: "0.5",
                          y: "0.5",
                          width: "39",
                          height: "39",
                          rx: "19.5",
                          stroke: "url(#paint1_linear_29_5066)"
                        }),
                        _createElementVNode("path", {
                          d: "M25.8334 12.5H14.1667C12.9882 12.5 12.399 12.5 12.0329 12.8435C11.6667 13.187 11.6667 13.7398 11.6667 14.8456V15.4204C11.6667 16.2853 11.6667 16.7177 11.8831 17.0762C12.0994 17.4347 12.4946 17.6571 13.2851 18.1021L15.7126 19.4687C16.243 19.7672 16.5081 19.9165 16.698 20.0813C17.0934 20.4246 17.3368 20.8279 17.4471 21.3226C17.5001 21.5602 17.5001 21.8382 17.5001 22.3941L17.5001 24.6187C17.5001 25.3766 17.5001 25.7556 17.71 26.0511C17.92 26.3465 18.2928 26.4923 19.0385 26.7838C20.6041 27.3958 21.3868 27.7018 21.9435 27.3537C22.5001 27.0055 22.5001 26.2099 22.5001 24.6187V22.3941C22.5001 21.8382 22.5001 21.5602 22.553 21.3226C22.6633 20.8279 22.9068 20.4246 23.3022 20.0813C23.492 19.9165 23.7572 19.7672 24.2875 19.4687L26.7151 18.1021C27.5055 17.6571 27.9007 17.4347 28.1171 17.0762C28.3334 16.7177 28.3334 16.2853 28.3334 15.4204V14.8456C28.3334 13.7398 28.3334 13.187 27.9673 12.8435C27.6012 12.5 27.0119 12.5 25.8334 12.5Z",
                          stroke: "white",
                          "stroke-width": "1.25"
                        }),
                        _createElementVNode("defs", null, [
                          _createElementVNode("linearGradient", {
                            id: "paint0_linear_29_5066",
                            x1: "20",
                            y1: "0",
                            x2: "20",
                            y2: "40",
                            gradientUnits: "userSpaceOnUse"
                          }, [
                            _createElementVNode("stop", {
                              "stop-color": "white",
                              "stop-opacity": "0.5"
                            }),
                            _createElementVNode("stop", {
                              offset: "1",
                              "stop-color": "white",
                              "stop-opacity": "0.16"
                            })
                          ]),
                          _createElementVNode("linearGradient", {
                            id: "paint1_linear_29_5066",
                            x1: "20",
                            y1: "0",
                            x2: "20",
                            y2: "40",
                            gradientUnits: "userSpaceOnUse"
                          }, [
                            _createElementVNode("stop", {
                              "stop-color": "white",
                              "stop-opacity": "0.16"
                            }),
                            _createElementVNode("stop", {
                              offset: "1",
                              "stop-color": "white",
                              "stop-opacity": "0.32"
                            })
                          ])
                        ])
                      ])
                    ], -1))
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", null, [
                      _createElementVNode("h2", _hoisted_11, _toDisplayString(_ctx.totalItems), 1),
                      _cache[9] || (_cache[9] = _createElementVNode("h6", { class: "partner-statistic-label" }, "Total Partners", -1))
                    ]),
                    _cache[10] || (_cache[10] = _createElementVNode("div", null, [
                      _createElementVNode("svg", {
                        width: "40",
                        height: "40",
                        viewBox: "0 0 40 40",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("rect", {
                          x: "0.5",
                          y: "0.5",
                          width: "39",
                          height: "39",
                          rx: "19.5",
                          fill: "url(#paint0_linear_29_5047)"
                        }),
                        _createElementVNode("rect", {
                          x: "0.5",
                          y: "0.5",
                          width: "39",
                          height: "39",
                          rx: "19.5",
                          stroke: "url(#paint1_linear_29_5047)"
                        }),
                        _createElementVNode("circle", {
                          cx: "20.0001",
                          cy: "15.0001",
                          r: "3.33333",
                          stroke: "white",
                          "stroke-width": "1.25"
                        }),
                        _createElementVNode("path", {
                          d: "M25 17.4999C26.3807 17.4999 27.5 16.5672 27.5 15.4166C27.5 14.266 26.3807 13.3333 25 13.3333",
                          stroke: "white",
                          "stroke-width": "1.25",
                          "stroke-linecap": "round"
                        }),
                        _createElementVNode("path", {
                          d: "M15 17.4999C13.6193 17.4999 12.5 16.5672 12.5 15.4166C12.5 14.266 13.6193 13.3333 15 13.3333",
                          stroke: "white",
                          "stroke-width": "1.25",
                          "stroke-linecap": "round"
                        }),
                        _createElementVNode("ellipse", {
                          cx: "20",
                          cy: "24.1666",
                          rx: "5",
                          ry: "3.33333",
                          stroke: "white",
                          "stroke-width": "1.25"
                        }),
                        _createElementVNode("path", {
                          d: "M26.6667 25.8334C28.1286 25.5128 29.1667 24.701 29.1667 23.7501C29.1667 22.7992 28.1286 21.9873 26.6667 21.6667",
                          stroke: "white",
                          "stroke-width": "1.25",
                          "stroke-linecap": "round"
                        }),
                        _createElementVNode("path", {
                          d: "M13.3333 25.8334C11.8714 25.5128 10.8333 24.701 10.8333 23.7501C10.8333 22.7992 11.8714 21.9873 13.3333 21.6667",
                          stroke: "white",
                          "stroke-width": "1.25",
                          "stroke-linecap": "round"
                        }),
                        _createElementVNode("defs", null, [
                          _createElementVNode("linearGradient", {
                            id: "paint0_linear_29_5047",
                            x1: "20",
                            y1: "0",
                            x2: "20",
                            y2: "40",
                            gradientUnits: "userSpaceOnUse"
                          }, [
                            _createElementVNode("stop", {
                              "stop-color": "white",
                              "stop-opacity": "0.5"
                            }),
                            _createElementVNode("stop", {
                              offset: "1",
                              "stop-color": "white",
                              "stop-opacity": "0.16"
                            })
                          ]),
                          _createElementVNode("linearGradient", {
                            id: "paint1_linear_29_5047",
                            x1: "20",
                            y1: "0",
                            x2: "20",
                            y2: "40",
                            gradientUnits: "userSpaceOnUse"
                          }, [
                            _createElementVNode("stop", {
                              "stop-color": "white",
                              "stop-opacity": "0.16"
                            }),
                            _createElementVNode("stop", {
                              offset: "1",
                              "stop-color": "white",
                              "stop-opacity": "0.32"
                            })
                          ])
                        ])
                      ])
                    ], -1))
                  ])
                ]),
                _createElementVNode("p", {
                  class: "selected-question-caption",
                  innerHTML: _ctx.getQuestionsString()
                }, null, 8, _hoisted_12)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass({
        'parent': true,
        'small-parent': _ctx.isFiltersOpen
      })
          }, [
            _createElementVNode("div", {
              class: _normalizeClass({
            'child': true,
            'small-child': _ctx.isFiltersOpen
          })
            }, [
              _createVNode(_component_new_card, {
                name: "Create New EMS Partner <br/> Questionnaire",
                onHandleClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push({ name: _ctx.rNewDocument })))
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_document_svg)
                ]),
                _: 1
              })
            ], 2),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documents, (document) => {
              return (_openBlock(), _createElementBlock("div", {
                key: document.id,
                class: _normalizeClass({
            'child': true,
            'small-child': _ctx.isFiltersOpen
          })
              }, [
                _createVNode(_component_document_card, {
                  id: document.id,
                  name: document.name,
                  "gradient-type": document.color,
                  "last-edited": document.updated_at,
                  progress: document.answers_progress / 100,
                  "filter-values": document.filter_values,
                  "is-update-pending": document.is_update_pending,
                  "business-function-id": _ctx.businessFunctionId,
                  document: document,
                  onClick: ($event: any) => (_ctx.goToQuizEdit(document.id)),
                  onOnArchive: _ctx.archiveQuiz
                }, null, 8, ["id", "name", "gradient-type", "last-edited", "progress", "filter-values", "is-update-pending", "business-function-id", "document", "onClick", "onOnArchive"])
              ], 2))
            }), 128))
          ], 2),
          _createElementVNode("div", _hoisted_13, [
            (_ctx.pageMeta.current_page)
              ? (_openBlock(), _createBlock(_component_pagination, {
                  key: 0,
                  "current-page": _ctx.pageMeta.current_page,
                  "total-pages": _ctx.pageMeta.total,
                  meta: _ctx.pageMeta,
                  onHandleClick: _ctx.navigateToPage
                }, null, 8, ["current-page", "total-pages", "meta", "onHandleClick"]))
              : _createCommentVNode("", true)
          ])
        ], 2),
        (_ctx.isFiltersOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "sidebar-filter-title" }, "Filters", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sidebarFilters, (filter) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: filter.id,
                  class: "filter-row"
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass({
          'filter-row-title': true,
          'filter-row-title-have-item-selected': _ctx.questionHaveSelectedValue(filter),
        }),
                    onClick: ($event: any) => (_ctx.toggleOpenFilters(filter.id))
                  }, _toDisplayString(filter.text), 11, _hoisted_15),
                  _createElementVNode("div", {
                    onClick: ($event: any) => (_ctx.toggleOpenFilters(filter.id)),
                    class: _normalizeClass({
            'filter-row-chevron': true,
            'filter-row-chevron-is-open': _ctx.isOpenFilter(filter.id)
          })
                  }, [...(_cache[11] || (_cache[11] = [
                    _createElementVNode("svg", {
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("path", {
                        d: "M6 9L12 15L18 9",
                        stroke: "#1F252D",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      })
                    ], -1)
                  ]))], 10, _hoisted_16),
                  (_ctx.isOpenFilter(filter.id))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filter.answer_values, (value, key) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: key,
                            onClick: ($event: any) => (_ctx.toggleQuestionForFiltering(filter.id, key)),
                            class: "option-list-item"
                          }, [
                            _createElementVNode("div", _hoisted_19, [
                              (_ctx.isQuestionItemSelected(filter.id, key))
                                ? (_openBlock(), _createBlock(_component_checked_svg, {
                                    key: 0,
                                    style: {"width":"20px","height":"20px"}
                                  }))
                                : (_openBlock(), _createElementBlock("span", _hoisted_20))
                            ]),
                            _createElementVNode("span", _hoisted_21, _toDisplayString(value), 1)
                          ], 8, _hoisted_18))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["onOnSearchBarSubmit"]))
}